import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/forms/FormCreator";
import { LoginFormData } from "./data/LoginForm.Data";
import Image from "../../components/ui/image/Image";
import { AppIcons } from "../../data/appIcons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useUserLoginMutation } from "../../app/services/login/authApi";
import ToastService from "../../services/toastService/ToastService";
import { authentication } from "../../app/slice/authSlice";
import Buttons from "../../components/ui/button/Buttons";
import { Link } from "react-router-dom";

const LoginForm = () => {
  const loginFormRef = useRef();
  const { isLogedin } = useSelector((state) => state.auth);
  const [loginForm, setloginForm] = useState(LoginFormData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Declare admin login API
  const [
    login,
    { isLoading: loginLoading, isSuccess: loginSuccess, data: authData },
  ] = useUserLoginMutation();

  useEffect(() => {
    if (!loginLoading && loginSuccess && authData) {
      if (authData.isAuthenticated === false) {
        ToastService.error(authData.message);
      } else if (authData.isAuthenticated === true) {
        ToastService.success("You are login successfully", "Success");
        console.log(authData, "authdata");
        dispatch(authentication(authData));
      }
    }
  }, [loginLoading, loginSuccess, authData]);

  // Effect to handle navigation based on the authentication
  useEffect(() => {
    if (isLogedin) {
      navigate(`/`);
    }
  }, [isLogedin]);

  const handleLogin = () => {
    // Retrieve form data
    const authData = loginFormRef.current?.getFormData();

    // Check if form data exists
    if (!authData) return;

    // Create the request object
    const request = {
      userName: authData.emailAddress,
      password: authData.password,
    };

    // Proceed with the login if form data exists
    login(request);
  };

  const handleDownloadPDF = async () => {
    navigate('/resetPassword/');
  }
  return (
    <div>
      <div className="login-application">
        <div className="login-page">
          <div className="login-page-logo">
            <Image
              imagePath={AppIcons.logoImage}
              imgCustomClassName="open-bar"
              altText="Icon"
            ></Image>
          </div>
          <div className="form-data">
            <FormCreator config={loginForm} ref={loginFormRef} key={false} />
          </div>
          <form>
            <div className="row">

              <div className='col-lg-12 col-sm-12 col-md-12 col-12 mt-2 text-end'>

                <Buttons buttonText=' Forgot your password?' onClick={handleDownloadPDF}></Buttons>

              </div>
            </div>
          </form>
          <div className="form-btn">
            <Buttons
              isLoading={loginLoading}
              isDisable={loginLoading}
              buttonTypeClassName={"btn theme-btn"}
              buttonText={"Login"}
              onClick={handleLogin}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
